module.exports = __webpack_public_path__ + "static/media/BG_10.a24a1764.png";